import { render, staticRenderFns } from "./myCourseList.vue?vue&type=template&id=396f2295&scoped=true&"
import script from "./myCourseList.vue?vue&type=script&lang=js&"
export * from "./myCourseList.vue?vue&type=script&lang=js&"
import style0 from "./myCourseList.vue?vue&type=style&index=0&id=396f2295&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396f2295",
  null
  
)

export default component.exports